import { render } from "./Bottom-Button.vue?vue&type=template&id=87b2499c"
import script from "./Bottom-Button.vue?vue&type=script&lang=js"
export * from "./Bottom-Button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__